// TODO: Fix eslint issues the next time this file is edited.
/* eslint-disable @next/next/link-passhref */
import React, { useEffect, useRef } from 'react';
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import { Block, Click, Flex, Spacer, Text, useTheme } from 'vcc-ui';
import { structure } from '../docs.config.js';

const Link = ({ children, href }) => {
  const router = useRouter();
  const ref = useRef();
  const pathname = router.pathname;

  useEffect(() => {
    if (href === pathname) {
      ref?.current?.scrollIntoView?.();
    }
  }, [href, pathname]);
  return (
    <NextLink href={href}>
      <Text
        ref={ref}
        subStyle="inline-link"
        extend={({ theme: { baselineSubGrid, color } }) => ({
          padding: `${baselineSubGrid}px ${3 * baselineSubGrid}px`,
          textDecoration: 'none',
          transition: 'all 130ms ease-out',
          borderRadius: 2,
          background:
            href === pathname ? color.ornament.divider : 'transparent',
          '&:hover': {
            background: color.ornament.divider,
          },
        })}
        href={href}
      >
        {children}
      </Text>
    </NextLink>
  );
};

const RenderItems = () => {
  return Object.keys(structure).map((key) => (
    <Flex
      extend={{
        flexShrink: 0,
      }}
      key={key}
    >
      <Text
        as="h2"
        variant="columbus"
        subStyle="emphasis"
        key={key}
        extend={({ theme: { baselineSubGrid } }) => ({
          padding: `${baselineSubGrid}px ${3 * baselineSubGrid}px`,
        })}
      >
        {key}
      </Text>
      <Spacer />
      {Array.isArray(structure[key]) &&
        structure[key].map((item) => (
          <Link key={item[0]} href={item[1]}>
            {item[0]}
          </Link>
        ))}

      {!Array.isArray(structure[key]) &&
        Object.keys(structure[key]).map((item) => (
          <Flex key={item}>
            <Spacer />
            <Text
              as="h3"
              variant="kelly"
              subStyle="emphasis"
              extend={({ theme: { baselineSubGrid } }) => ({
                padding: `${baselineSubGrid}px ${3 * baselineSubGrid}px`,
              })}
            >
              {item}
            </Text>
            {structure[key][item].map((subItem) => (
              <Link key={subItem[1]} href={subItem[1]}>
                {subItem[0]}
              </Link>
            ))}
          </Flex>
        ))}
      <Spacer size={4} />
    </Flex>
  ));
};

const DocsNavigation = ({ setMobileNavOpen, mobileNavOpen }) => {
  const theme = useTheme();
  return (
    <Flex
      extend={{
        flexDirection: 'column',
        background: theme.color.background.secondary,
        position: 'fixed',
        [theme.breakpoints.fromL]: {
          paddingTop: 40,
          marginLeft: '-999px',
          paddingLeft: '960px',
          maxWidth: 240,
        },
        [theme.breakpoints.untilL]: {
          display: mobileNavOpen ? 'flex' : 'none',
          boxSizing: 'border-box',
          zIndex: 100,
          padding: 32,
          top: '0px',
          left: '0px',
          right: '0px',
        },
      }}
    >
      <Click
        extend={{
          padding: '4px 0px',
          display: 'none',
          [theme.breakpoints.untilL]: {
            display: 'flex',
            flexShrink: 0,
          },
          alignItems: 'center',
        }}
        onClick={() => {
          setMobileNavOpen(!mobileNavOpen);
        }}
      >
        <Block
          extend={{
            fill: theme.color.foreground.primary,
          }}
          as="svg"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
          <path d="M0 0h24v24H0z" fill="none" />
        </Block>
        <Spacer />
        <Text subStyle="inline-link">Close</Text>
      </Click>
      <Spacer size={{ default: 4, [theme.breakpoints.fromL]: 8 }} />
      <Flex
        extend={{
          padding: '0 38px 32px 0',
          margin: 0,
          overflowY: 'scroll',
          height: 'calc(100vh - 80px)',
        }}
      >
        <RenderItems />
        <Spacer size={12} />
      </Flex>
    </Flex>
  );
};

export default DocsNavigation;
